import { WarningAmber } from '@mui/icons-material';
import { Box, Tooltip, Typography } from '@mui/material';
import { useStudioUnauthenticatedContext } from '../../context/StudioContext';
import { studioFooterStyles } from './StudioFooter.styles';

export const StudioFooterBackendVersion = () => {
  const { portalVersion, servicesApiVersion, servicesEnvironment } =
    useStudioUnauthenticatedContext();

  const envLabel =
    servicesEnvironment === 'local'
      ? 'local'
      : servicesEnvironment === 'stage'
        ? 'stage'
        : servicesEnvironment === 'prod'
          ? 'prod'
          : 'unknown';

  const envBadge = (() => {
    switch (servicesEnvironment) {
      case 'prod':
        return {
          bgcolor: 'success.main',
          color: 'common.white',
          tooltip: 'Connected to production backend',
        };
      case 'stage':
        return {
          bgcolor: 'warning.main',
          color: 'common.white',
          tooltip: 'Connected to staging backend',
        };
      case 'local':
        return {
          bgcolor: 'error.main',
          color: 'common.white',
          tooltip: 'Connected to local backend',
        };
      case 'unknown':
      default:
        return {
          bgcolor: 'grey.500',
          color: 'common.white',
          tooltip: 'Connected to unknown backend environment',
        };
    }
  })();

  const backendVersionText = servicesApiVersion ?? 'unknown';
  const versionMismatch =
    servicesApiVersion !== null && servicesApiVersion !== portalVersion;

  return (
    <Box sx={studioFooterStyles.rightSide}>
      <Tooltip title={envBadge.tooltip}>
        <Box
          sx={{
            ...studioFooterStyles.envPill,
            bgcolor: envBadge.bgcolor,
            color: envBadge.color,
          }}
        >
          {envLabel}
        </Box>
      </Tooltip>

      <Typography variant="caption" color="text.secondary">
        Backend {backendVersionText}
      </Typography>

      {versionMismatch && (
        <Tooltip
          title={`Version mismatch: frontend v${portalVersion} vs backend v${servicesApiVersion}.`}
        >
          <Box sx={studioFooterStyles.mismatchPill}>
            <WarningAmber sx={studioFooterStyles.mismatchIcon} />
            Version mismatch
          </Box>
        </Tooltip>
      )}
    </Box>
  );
};
